module.exports = __webpack_public_path__ + "static/media/Logo.b89ebf20.png";